import styled from '@emotion/styled'
import { Card } from 'react-bootstrap'
import { PrimaryButton } from '@mmsg/louie'
import InformationBlock from '@mmsg/louie/dist/InformationBlock/InformationBlock' // why?

export const EstimateItemStyled = styled.div`
  label: EstimateItemStyled;
  .estimate-item {
    max-width: 404px;
    display: inline-block;
    border: 1px solid ${(props) => props.theme.colors.borderColor};
    margin: 2px;
    &__savings {
      font-weight: ${(props) => props.theme.font.weight.semiBold};
      line-height: 32px;
    }
    &__normal-black {
      font-size: 18px;
      color: ${(props) => props.theme.colors.textDarkblack};
    }
    &__benefit {
      text-align: left;
      font-size: 18px;
      display: flex;
      align-items: baseline;
      color: ${(props) => props.theme.colors.textDarkblack};
      > img {
        margin-right: 2px;
      }
    }
    .btn.bg-brand {
      border-radius: 40px;
    }
    .row-spacing {
      padding: 12px 0;
    }
    .btn.btn-view-details {
      width: 179px;
      padding: 12px;
    }
    .txt-header {
      padding: 12px;
      background: $card-cap-bg;
      color: ${(props) => props.theme.colors.textDarkblack};
    }
  }
  .highlight {
    border: 1px solid ${(props) => props.theme.colors.secondary};
    border-radius: 3px;
  }
  .spartaHighlight {
    border-color: ${(props) => props.theme.colors.spartaGreen};
  }
`
export const CarImageStyled = styled.div`
  label: CarImageStyled;
  text-align: center;
  position: relative;
  padding-bottom: 32px;
  img {
    width: 280px;
    height: 169px;
  }
  > svg {
    margin: 0 auto;
    width: 100%;
    height: 270px;
    @media (min-width: ${(props) => props.theme.mq.md}) {
      width: 457px;
    }
  }
  p {
    margin: 0;
    padding: 0;
    font-size: 14px;
    color: ${(props) => props.theme.colors.textDarkblack};
  }
`
export const Heading2 = styled.h2`
  label: Heading2;
  font-size: 34px;
  color: ${(props) => props.theme.colors.textDarkblack};
  font-weight: ${(props) => props.theme.font.weight.semiBold};
`

export const Heading3 = styled.div`
  label: Heading3;
  margin-bottom: 6px;
  margin-top: 6px;
  color: ${(props) => props.theme.colors.yield};
  font-weight: ${(props) => props.theme.font.weight.semiBold};
`


export const CardHeader = styled(Card.Header)`
  label: CardHeaderStyled;
  padding: 9px 16px;
  background: ${(props) =>
    props.invalid
      ? props.theme.colors.lightBackground
      : props.theme.colors.secondary};
  color: ${(props) =>
    props.invalid ? props.theme.colors.textLightblack : 'white'};
  font-weight: 900;
  border-bottom: none;
  position: relative;
  border-radius: 3px 3px 0 0 !important;
  text-align: center;
`

export const SpartaCardHeader = styled(CardHeader)`
  label: SpartaCardHeader;
  background: ${(props) =>
    props.invalid
      ? props.theme.colors.lightBackground
      : props.theme.colors.spartaGreen};
`

export const CardBody = styled(Card.Body)`
  label: CardBody;
`
//TODO(VJ): both of  the the bottom components can be a paramenter passed to LOUIE
export const EstimateItemPrimaryButton = styled(PrimaryButton)`
  label: EstimateItemPrimaryButton;
  background: ${(props) =>
    props.isSparta
      ? props.theme.colors.spartaGreen
      : props.theme.colors.primary};
  border-color: ${(props) =>
    props.isSparta
      ? props.theme.colors.spartaGreen
      : props.theme.colors.primary};
  &:hover {
    background: ${(props) =>
      props.isSparta
        ? props.theme.colors.positive2
        : props.theme.colors.primaryButtonHover};
    border-color: ${(props) =>
      props.isSparta
        ? props.theme.colors.positive2
        : props.theme.colors.primaryButtonHover};
  }
`
export const EstimateItemInfoBlock = styled(InformationBlock)`
  label: EstimateItemInfoBlock;
  > div > div:nth-child(1) {
    color: ${(props) =>
      props.isSparta
        ? props.theme.colors.spartaGreen
        : props.theme.colors.secondary};
  }
  background-color:${(props) => props.theme.backgrounds.backGround1}
`

export const SpartaBlock = styled.div`
  label: SpartaBlock;
  position: absolute;
  bottom: 0;
  width: 220px;
  left: 50%;
  transform: translateX(-50%);
`
export const LinkContainer = styled.div`
  label: LinkContainer;
  span > a {
    color: ${(props) =>
      props.isSparta
        ? props.theme.colors.spartaGreen
        : props.theme.colors.secondary};
    font-weight: ${(props)=> props.theme.font.weight.semiBold};
  }
`
export const ImageText = styled('div')`
  label: ImageText;
  text-align: center;
  margin-top: 15px;
`
export const ListContainer = styled('div')`
  label: ListContainer;
  border-radius: 4px;
  max-width: 1140px;
  padding: 9px;
  margin: 0 auto;
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  position: absolute;
  height: 51px;
  top: -40px;
  border: 1px solid ${(props) => props.theme.colors.borderColor};
`

export const OlyCaption = styled.div`
  label: OlyCaption;
  font-size: ${(props) => props.theme.font.size.medium};
  font-weight: ${(props) => props.theme.font.weight.bold};
  color: ${(props) => props.theme.colors.textDarkblack};
  text-align: center;
`

export const HideBox = styled('div')`
  label: HideBox;
  display: flex;
  z-index: 1;
  align-items: baseline;
  > div:first-child {
    cursor: pointer;
    > div {
      display: flex;
      align-items: center;
    }
  }
`

export const CarousalNav = styled('div')`
  label: CarousalNav;
  display: flex;
  justify-content: end;
  align-items: center;
`

export const NavCount = styled('div')`
  label: NavCount;
  display: flex;
  align-items: center;
  margin-right: 12px;
`
export const NavButton = styled('button')`
  label: NavButton;
  border: none;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  background: none;
  padding: 0;
`
export const TickItemDiv = styled.div`
  label: TickItemDiv;
  display: flex;
  align-items: baseline;
`
export const ReleaseCard = styled.div`
  label: ReleaseCard;
  background-color: ${(props) =>
    props.positive
      ? props.theme.colors.alertGreen2
      : props.theme.backgrounds.backGround2};
  color: ${(props) =>
    props.positive
      ? props.theme.colors.alertGreen
      : props.theme.colors.textDarkblack};
  font-weight: 550;
  border-radius: 3px !important;
  margin: 3px;
  text-align: center;
  font-size: 16px;
  line-height: 22px;
  box-sizing: border-box;
  padding: 12px;
  max-width: 404px;
`
